import { createContext } from 'react';

export const SwipeableDrawerContext = createContext<{ hasPadding: boolean }>({
  hasPadding: true,
});
